module.exports = {
	"id": "BN",
	"name": "Brunei Darussalam",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.002974,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.01487,
			"12": 0.005948,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.005948,
			"19": null,
			"20": null,
			"21": 0.008922,
			"22": 0.017844,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.011896,
			"27": 0.005948,
			"28": 0.017844,
			"29": null,
			"30": 0.002974,
			"31": 0.026766,
			"32": 0.011896,
			"33": 0.077324,
			"34": 0.005948,
			"35": 0.005948,
			"36": 0.020818,
			"37": 0.011896,
			"38": 0.017844,
			"39": 0.047584,
			"40": 0.011896,
			"41": 0.011896,
			"42": 0.005948,
			"43": 0.080298,
			"44": 0.023792,
			"45": 0.020818,
			"46": 0.035688,
			"47": 0.035688,
			"48": 0.026766,
			"49": 0.969524,
			"50": 0.065428,
			"51": 0.288478,
			"52": 0.202232,
			"53": 13.156976,
			"54": 2.88478,
			"55": 0.092194,
			"56": 0.020818,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.01487,
			"4": 0.005948,
			"5": null,
			"6": 0.005948,
			"7": 0.002974,
			"8": null,
			"9": 0.01487,
			"10": 0.002974,
			"11": 0.002974,
			"12": 0.005948,
			"13": 0.005948,
			"14": null,
			"15": null,
			"16": 0.020818,
			"17": 0.005948,
			"18": 0.005948,
			"19": 0.002974,
			"20": null,
			"21": 0.002974,
			"22": null,
			"23": null,
			"24": 0.005948,
			"25": 0.005948,
			"26": null,
			"27": 0.005948,
			"28": 0.002974,
			"29": 0.01487,
			"30": 0.005948,
			"31": 0.017844,
			"32": 0.065428,
			"33": 0.008922,
			"34": 0.005948,
			"35": 0.011896,
			"36": 0.062454,
			"37": 0.011896,
			"38": 0.026766,
			"39": 0.035688,
			"40": 0.032714,
			"41": 0.017844,
			"42": 0.038662,
			"43": 0.092194,
			"44": 0.041636,
			"45": 0.053532,
			"46": 0.086246,
			"47": 0.270634,
			"48": 0.419334,
			"49": 3.072142,
			"50": 0.395542,
			"51": null,
			"52": 0.002974,
			"3.5": null,
			"3.6": 0.01487
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.002974,
			"31": null,
			"32": 0.002974,
			"33": null,
			"34": 0.005948,
			"35": 0.01487,
			"36": 0.008922,
			"37": 0.157622,
			"38": 0.005948,
			"39": null,
			"40": 0.181414,
			"41": 0.023792,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.011896
		},
		"safari": {
			"0": null,
			"4": 0.002974,
			"5": 0.035688,
			"6": 0.008922,
			"7": 0.020818,
			"8": 0.113012,
			"9": 0.157622,
			"10": 0.770266,
			"3.1": null,
			"3.2": null,
			"5.1": 0.068402,
			"6.1": 0.041636,
			"7.1": 0.005948,
			"9.1": 0.591826
		},
		"ios_saf": {
			"8": 0,
			"10": 6.03645206078,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.162675398106,
			"8.1-8.4": 0.300535904975,
			"9.0-9.2": 0.143374927144,
			"9.3": 2.18738670899
		},
		"android": {
			"3": 0,
			"4": 0.103940956072,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.012992619509,
			"4.1": 0.374929877261,
			"4.2-4.3": 0.937324693152,
			"4.4": 2.1493504845,
			"4.4.3-4.4.4": 2.16791136951
		},
		"ie": {
			"6": null,
			"7": 0.005971234375,
			"8": 0.116439070313,
			"9": 0.146295242188,
			"10": 0.08359728125,
			"11": 1.1225920625,
			"5.5": null
		},
		"op_mob": {
			"0": 2.08464249365,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0579067359347
		},
		"edge": {
			"12": 0.115986,
			"13": 0.127882,
			"14": 0.365802
		},
		"ie_mob": {
			"10": 0.0138521126761,
			"11": 0.0563978873239
		},
		"bb": {
			"7": 0.0035125,
			"10": null
		},
		"samsung": {
			"0": 4.292275
		},
		"and_uc": {
			"0": 5.66215
		},
		"op_mini": {
			"0": 28.0860257704
		},
		"and_chr": {
			"0": 16.348253
		},
		"and_ff": {
			"0": 0.04215
		}
	},
	"total": 98.7244093906
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/BN.json
 ** module id = 481
 ** module chunks = 0
 **/